export default __webpack_public_path__ + "static/1217-9d621e47a6219e258f30a0f536887d72.gif";